import React, {Component} from 'react';
import {OrderBookContainer} from "../containers/OrderBookContainer";
import {Col, Row} from "antd";
import {OrderTransactionContainer} from "../containers/OrderTransactionContainer";
import RightPanelContainer from '../containers/RightPanelContainer';
import DeepChart from "./exchange/DeepChart";
import {TVChartContainer} from "./exchange/TVChart";
import consts, {PREFIX_FRONT_URL} from "../consts";
import ExchangeSelectContainer from "../containers/ExchangeSelectContainer";
import {Regis, RegisPrivate, UnRegis, UnRegisPrivate} from "../websocket/EventHandle";

class Exchange extends Component {
	constructor(props) {
		super(props);
		const query = this.useQuery();
		let pair = query.get("currency");
		if (!window._.isEmpty(pair)) {
			var [coin, currency] = pair.split('/');
		}

		this.state = {
			coin: coin || 'BTC',
			currency: currency || 'USDT',
			orderType: 'Limit',
			tradeType: 'Buy',
			clickOrderBook: true,
			interval: 5,
		};

		this.changeMarket = this.changeMarket.bind(this);
		this.useQuery = this.useQuery.bind(this);
	}

	componentDidMount() {
		const query = this.useQuery();
		let pair = query.get("currency");
		let {coin, currency} = this.state;
		this.RegisPrivateEvents();

		if (window._.isEmpty(pair)) {
			pair = 'BTC/USDT';
		}
		
		if (!window._.isEmpty(pair)) {
			const [queryCoin, queryCurrency] = pair.split('/');
			coin = queryCoin;
			currency = queryCurrency;
			
			this.setState({coin, currency});
			this.changeMarket(coin, currency);
		}
	}

	componentWillUnmount() {
		this.UnRegisEvents();
	}

	RegisEvents = (pCoin = undefined, pCurrency = undefined) => {
		const {coin, currency} = this.state;
		this.RegisPrivateEvents();
		this.RegisPublicEvents(pCoin || coin, pCurrency || currency);
	}
	
	RegisPrivateEvents = () => {
		if (window.$isAuthenticated) {
			RegisPrivate(consts.WS_EVENT_ORDER_CREATED);
			RegisPrivate(consts.WS_EVENT_ORDER_CANCELED);
			RegisPrivate(consts.WS_EVENT_OPEN_ORDER);
		}
	}
	
	UnRegisPrivateEvent = () => {
		if (window.$isAuthenticated) {
			UnRegisPrivate(consts.WS_EVENT_ORDER_CREATED);
			UnRegisPrivate(consts.WS_EVENT_ORDER_CANCELED);
			UnRegisPrivate(consts.WS_EVENT_OPEN_ORDER);
		}
	}
	
	RegisPublicEvents = (coin, currency) => {
		Regis(consts.WS_EVENT_UPDATE_BATCH_ORDER_TRANSACTION, `${consts.WS_EVENT_UPDATE_BATCH_ORDER_TRANSACTION}:${coin}:${currency}`);
		Regis(consts.WS_EVENT_PUBLIC_BATCH_ORDER_BOOKS_SELL, `${consts.WS_EVENT_PUBLIC_BATCH_ORDER_BOOKS_SELL}:${coin}:${currency}`);
		Regis(consts.WS_EVENT_PUBLIC_BATCH_ORDER_BOOKS_BUY, `${consts.WS_EVENT_PUBLIC_BATCH_ORDER_BOOKS_BUY}:${coin}:${currency}`);
		Regis(consts.WS_EVENT_PUBLIC_ORDER_BOOK, `${consts.WS_EVENT_PUBLIC_ORDER_BOOK}:${coin}:${currency}`);
		Regis(consts.WS_EVENT_LAST_PRICE, `${consts.WS_EVENT_LAST_PRICE}:${coin}:${currency}`);
	}
	
	UnRegisPublicEvents = () => {
		UnRegis(consts.WS_EVENT_UPDATE_BATCH_ORDER_TRANSACTION);
		UnRegis(consts.WS_EVENT_PUBLIC_BATCH_ORDER_BOOKS_SELL);
		UnRegis(consts.WS_EVENT_PUBLIC_BATCH_ORDER_BOOKS_BUY);
		UnRegis(consts.WS_EVENT_PUBLIC_ORDER_BOOK);
		UnRegis(consts.WS_EVENT_LAST_PRICE);
	}

	UnRegisEvents = () => {
		this.UnRegisPublicEvents();
		this.UnRegisPrivateEvent();
	}

	useQuery() {
		return new URLSearchParams(this.props.history.location.search);
	}

	changeMarket(coin, currency) {
		this.setState({coin, currency});
		this.props.onfetchAllOrderTransactionAction({
			coin,
			currency,
		});
		this.props.onFetchAllOrderBookAction({
			coin,
			currency,
		});
		this.props.onfetchPrice24hAction({
			coin,
			currency,
		});
		this.props.onfetchStickPriceAction({
			coin,
			currency,
			duration: 60000000, // 1 min
		});
		this.props.history.push(`${PREFIX_FRONT_URL}/?currency=${coin}/${currency}`);
		this.UnRegisPublicEvents();
		this.RegisPublicEvents(coin, currency);
	}

	render() {
		const lastPrice = () => {
			if (!this.props.setting.currencyMarkets) {
				return '';
			}
			return window._.get(window._.find(this.props.setting.currencyMarkets[this.state.currency], ['coin', this.state.coin]), 'last_price', '');
		}

		return (
			<div className="exchange-wrap">
				<Row>
					<Col span={24}>
						<ExchangeSelectContainer coins={this.props.setting.coins || []}
						                         markets={this.props.setting.currencyMarkets || {}}
						                         mapMarkets={this.props.setting.mapCurrencyMarkets || {}}
						                         coin={this.state.coin}
						                         currency={this.state.currency}
						                         changeMarket={this.changeMarket}
						                         balance={this.props.user.userBalances}
						                         history={this.props.history}
						                         name={this.props.user.info.email || ''}
																		 logout={this.props.logout}
						/>
					</Col>
				</Row>
				<Row gutter={10} className="custom-row-exchange">
					<Col span={4} className="scroll scroll-0">
						<OrderTransactionContainer coin={this.state.coin}
						                           currency={this.state.currency}
						                           orderClick={(tradeType, orderType = 'Limit') => {
							                           this.setState({
								                           tradeType,
								                           orderType,
								                           clickOrderBook: !this.state.clickOrderBook
							                           });
						                           }}/>
					</Col>
					<Col xxl={16} xl={14.5} lg={14} style={{ height: "100%" }}>
						<div style={{height: '100%'}}>
							<div className="tv-chart-wrap">
								<TVChartContainer symbol={`${this.state.coin}:${this.state.currency}`}/>
							</div>
							<div className="mt-small deep-chart-wrap">
								<Row gutter={5} className="full-height">
									<Col span={8} className="full-height">
										<DeepChart buy={this.props.book.buyOrderBooks}
													sell={this.props.book.sellOrderBooks}
										           lastPrice={lastPrice()} currency={`${this.state.currency}`.toUpperCase()}
										           coin={`${this.state.coin}`.toUpperCase()}
										           makeOrderBookEmpty={this.props.makeOrderBookEmpty}/>
									</Col>
									<Col span={16} className="full-height">
										<OrderBookContainer coin={this.state.coin}
										                    currency={this.state.currency}
										                    orderClick={(tradeType, orderType = 'Limit') => {
											                    this.setState({
												                    tradeType,
												                    orderType,
												                    clickOrderBook: !this.state.clickOrderBook
											                    });
										                    }}/>
									</Col>
								</Row>
							</div>
						</div>
					</Col>
					<Col xxl={4} xl={5.5} lg={6} className="panel-right">
						<RightPanelContainer coin={this.state.coin} currency={this.state.currency}
						                     tradeType={this.state.tradeType} orderType={this.state.orderType}
						                     clickOrderBook={this.state.clickOrderBook}
						                     orderClick={(tradeType, orderType = 'Limit') => {
							                     this.setState({
								                     tradeType,
								                     orderType,
								                     clickOrderBook: !this.state.clickOrderBook
							                     });
						                     }}
						/>
					</Col>
				</Row>
			</div>
		);
	}
}

export default Exchange;
